export const HOST_STATUSES_PATH = '/host_statuses';



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/routes/HostStatuses/constants.js